import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { RunOnceScheduler } from 'vscode/vscode/vs/base/common/async';
import { IModelService } from 'vscode/vscode/vs/editor/common/services/model';
import { IWorkspaceContextService } from 'vscode/vscode/vs/platform/workspace/common/workspace.service';
import { OUTPUT_MODE_ID, LOG_MODE_ID } from 'vscode/vscode/vs/workbench/services/output/common/output';
import { createWebWorker } from 'vscode/vscode/vs/editor/browser/services/webWorker';
import { dispose } from 'vscode/vscode/vs/base/common/lifecycle';
import { ILanguageConfigurationService } from 'vscode/vscode/vs/editor/common/languages/languageConfigurationRegistry';
import { ILanguageFeaturesService } from 'vscode/vscode/vs/editor/common/services/languageFeatures';

var OutputLinkProvider_1;
let OutputLinkProvider = class OutputLinkProvider {
    static { OutputLinkProvider_1 = this; }
    static { this.DISPOSE_WORKER_TIME = 3 * 60 * 1000; }
    constructor(contextService, modelService, languageConfigurationService, languageFeaturesService) {
        this.contextService = contextService;
        this.modelService = modelService;
        this.languageConfigurationService = languageConfigurationService;
        this.languageFeaturesService = languageFeaturesService;
        this.disposeWorkerScheduler = ( new RunOnceScheduler(() => this.disposeWorker(), OutputLinkProvider_1.DISPOSE_WORKER_TIME));
        this.registerListeners();
        this.updateLinkProviderWorker();
    }
    registerListeners() {
        this.contextService.onDidChangeWorkspaceFolders(() => this.updateLinkProviderWorker());
    }
    updateLinkProviderWorker() {
        const folders = this.contextService.getWorkspace().folders;
        if (folders.length > 0) {
            if (!this.linkProviderRegistration) {
                this.linkProviderRegistration = this.languageFeaturesService.linkProvider.register([{ language: OUTPUT_MODE_ID, scheme: '*' }, { language: LOG_MODE_ID, scheme: '*' }], {
                    provideLinks: async (model) => {
                        const links = await this.provideLinks(model.uri);
                        return links && { links };
                    }
                });
            }
        }
        else {
            dispose(this.linkProviderRegistration);
            this.linkProviderRegistration = undefined;
        }
        this.disposeWorker();
        this.disposeWorkerScheduler.cancel();
    }
    getOrCreateWorker() {
        this.disposeWorkerScheduler.schedule();
        if (!this.worker) {
            const createData = {
                workspaceFolders: ( this.contextService.getWorkspace().folders.map(folder => ( folder.uri.toString())))
            };
            this.worker = createWebWorker(this.modelService, this.languageConfigurationService, {
                moduleId: 'vs/workbench/contrib/output/common/outputLinkComputer',
                createData,
                label: 'outputLinkComputer'
            });
        }
        return this.worker;
    }
    async provideLinks(modelUri) {
        const linkComputer = await this.getOrCreateWorker().withSyncedResources([modelUri]);
        return linkComputer.computeLinks(( modelUri.toString()));
    }
    disposeWorker() {
        if (this.worker) {
            this.worker.dispose();
            this.worker = undefined;
        }
    }
};
OutputLinkProvider = OutputLinkProvider_1 = ( __decorate([
    ( __param(0, IWorkspaceContextService)),
    ( __param(1, IModelService)),
    ( __param(2, ILanguageConfigurationService)),
    ( __param(3, ILanguageFeaturesService))
], OutputLinkProvider));

export { OutputLinkProvider };
